<template>
  <div class="f-pagination-wrapper" :class="{ fixed }">
    <div class="f-pagination" :style="{ left }">
      <el-pagination
        ref="pagination"
        prev-text="上一页"
        next-text="下一页"
        layout="total, sizes, prev, pager, next, jumper"
        v-bind="$attrs"
        v-on="$listeners"
        :total="total"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        @size-change="handleChange($event, 'pageSize')"
        @current-change="handleChange($event, 'pageNum')"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fixed: {
      // 是否固定到底部
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default: () => [5, 10, 20, 30, 40, 50, 100]
    }
  },
  computed: {
    // 系统左侧菜单是否折叠
    menuCollapse() {
      return this.$store.state.settings.menuCollapse;
    },
    left() {
      let left;
      if (this.fixed) {
        if (this.menuCollapse) {
          left = "58px";
        } else {
          left = "230px";
        }
      }
      return left;
    }
  },
  watch: {
    total: {
      immediate: true,
      handler() {
        this.handlePaginationTotalHTML();
      }
    }
  },
  methods: {
    // 调整total html的样式
    handlePaginationTotalHTML() {
      this.$nextTick(() => {
        const elPagination = this.$refs.pagination.$el;
        const elTotal = elPagination.querySelector(".el-pagination__total");
        elTotal.innerHTML = `共<span class="f-pagination__total">${this.total}</span>条`;
      });
    },
    // 当前页数 页面总数 变化时
    handleChange(num, type) {
      let pageNum = this.pageNum;
      let pageSize = this.pageSize;
      if (type === "pageNum") {
        pageNum = num;
        this.$emit("update:pageNum", num);
      } else {
        pageSize = num;
        this.$emit("update:pageSize", num);
      }
      this.$emit("change", { pageNum, pageSize });
    }
  }
};
</script>

<style scoped lang="scss">
.f-pagination-wrapper {
  height: 50px;
  .f-pagination {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  &.fixed {
    .f-pagination {
      position: fixed;
      left: 160px;
      right: 0;
      bottom: 0;
      z-index: 99;
      background: #fff;
      box-shadow: 0px -4px 16px 0px rgba(9, 1, 3, 0.11);
    }
  }
  ::v-deep .el-pagination {
    .f-pagination__total {
      text-align: center;
      font-weight: bold;
      color: #f56c6c;
    }
  }
}
</style>
